export default __webpack_public_path__ + "static/media/icon3.214ec181.svg";